<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <!-- Título y subtítulo -->
      <v-row justify="start" align="start" class="ma-0 mb-4 mt-5">
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: black;">
            Facturas registradas
          </div>
        </v-col>
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-regular'; font-size: 14px;">
            Revisa y selecciona facturas para generar una disposición.
          </div>
        </v-col>
      </v-row>

      <!-- Buscador -->
      <v-row class="ma-0 mb-4" style="align-items: center;">
        <v-col cols="12" sm="4" md="3" class="pl-0">
          <v-text-field
            v-model="search"
            label="Buscar por referencia"
            hide-details
            append-icon="mdi-magnify"
            outlined
            style="font-family: 'montserrat-medium'; border-radius: 20px; background-color: white;"
          />
        </v-col>
        <v-spacer />
        <v-btn rounded color="black" class="white--text" @click="dialogCreateInvoice = true, factura = {}" style="font-family: 'montserrat-bold';">
          Nueva factura
        </v-btn>
        <v-btn color="black" class="white--text" rounded style="font-family: 'montserrat-bold'; margin-left: 10px;"
          :disabled="facturasSeleccionadas.length === 0"
          @click="dialogDisposicion = true, getCreditLine(facturasSeleccionadas[0])"
          >
          Generar disposición
        </v-btn>
      </v-row>

      <!-- Tabla de contratos -->
      <v-data-table
        :items="filteredFacturas"
        hide-default-header
        >
        <template v-slot:header>
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left"></th>
              <th class="header__title center">Cliente</th>
              <th class="header__title center">Proveedor</th>
              <th class="header__title center">Id</th>
              <th class="header__title center">Reference</th>
              <th class="header__title center">Monto</th>
              <th class="header__title center">Fecha de emisión</th>
              <th class="header__title center">Fecha de vencimiento</th>
              <th class="header__title center">Status</th>
              <th class="header__title right">Acciones</th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id">
              <td class="table__item">
                <v-checkbox
                  color="black"
                  v-model="facturasSeleccionadas"
                  :value="item"
                  :disabled="item.status !== 'pending' || (clienteSeleccionado && item.sEnterpriseId !== clienteSeleccionado)"
                ></v-checkbox>
              </td>
              <td class="table__item">{{ item.enterprise_name }}</td>
              <td class="table__item">{{ item.provider }}</td>
              <td class="table__item">{{ item.invoice_id }}</td>
              <td class="table__item">{{ item.reference }}</td>
              <td class="table__item">${{ formatMoney(item.amount) + " " + item.currency }}</td>
              <td class="table__item center">{{ formatDate(item.issue_date) }}</td>
              <td class="table__item center">{{ formatDate(item.due_date) }}</td>
              <td class="table__item center">
                <v-chip :color="statusColor(item.status)" small dark style="text-transform: capitalize;">{{ item.status }}</v-chip>
              </td>
              <td class="table__item center">
                <v-btn v-if="item.has_document" color="black" icon @click="viewDocument(item)">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <v-dialog v-model="dialogCreateInvoice" max-width="650px">
        <v-card style="border-radius: 20px; padding: 24px;">
          <v-form ref="formNew" lazy-validation v-on:submit.prevent>
            <!-- Título -->
            <div style="font-family: 'montserrat-bold'; font-size: 22px; text-align: center;">
              Agregar Factura
            </div>
            <v-divider class="my-4" />
            <!-- Información básica -->
            <v-row dense>
              <v-col cols="6">
                <v-select
                  v-model="factura.sEnterpriseId"
                  :items="enterprisesList"
                  item-text="enterprise_name"
                  item-value="enterprise_id"
                  label="Cliente"
                  style="border-radius: 10px;"
                  outlined
                  class="mb-2"
                  :rules="[rules.required]"
                  hide-details
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="6">
                <v-text-field
                  v-model="factura.invoice_id"
                  label="Id"
                  outlined
                  style="border-radius: 10px;"
                  class="mb-2"
                  hide-details
                  :rules="[rules.required]"
                  required
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="factura.reference"
                  label="Referencia interna (opcional)"
                  style="border-radius: 10px;"
                  outlined
                  class="mb-2"
                  hide-details
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="6">
                <v-text-field
                  v-model="factura.amount"
                  label="Monto"
                  outlined
                  style="border-radius: 10px;"
                  class="mb-2"
                  hide-details
                  :rules="[rules.required]"
                  required
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="factura.currency"
                  :items="['USD', 'MXN']"
                  label="Moneda"
                  style="border-radius: 10px;"
                  outlined
                  class="mb-2"
                  :rules="[rules.required]"
                  hide-details
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-card
                  flat
                  class="d-flex align-center justify-center flex-column py-2"
                  style="background-color: #f6f6f6; border-radius: 12px; height: 100%; "
                >
                  <div class="mb-1" style="font-family: 'montserrat-bold'; font-size: 14px; color: #333;">
                    Monto total de la factura
                  </div>
                  <div style="font-family: 'montserrat-bold'; font-size: 20px; color: #333;">
                    {{ factura.amount ? ("$" + formatMoney(factura.amount) + " " + (factura.currency ? factura.currency : "")) : "$0.00" }}
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-row dense class="mt-4">
            <v-col cols="6">
              <v-menu
                ref="menuEmision"
                color="black"
                v-model="menuEmision"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="factura.issue_date"
                    label="Fecha de Emisión"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="[rules.required]"
                    style="border-radius: 10px;"
                    class="mb-2"
                    outlined
                    hide-details
                  />
                </template>
                <v-date-picker color="black" v-model="factura.issue_date" @input="menuEmision = false" />
              </v-menu>
            </v-col>

            <v-col cols="6">
              <v-menu
                ref="menuVencimiento"
                v-model="menuVencimiento"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="factura.due_date"
                    label="Fecha de Vencimiento"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    style="border-radius: 10px;"
                    outlined
                    :rules="[rules.required]"
                    hide-details
                    class="mb-2"
                  />
                </template>
                <v-date-picker color="black" v-model="factura.due_date" @input="menuVencimiento = false" />
              </v-menu>
            </v-col>
          </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-file-input
                  v-model="pdfFile"
                  label="Documento (PDF)"
                  accept=".pdf"
                  outlined
                  style="border-radius: 10px;"
                  class="mb-2"
                  hide-details
                  prepend-icon="mdi-paperclip"
                />
              </v-col>
            </v-row>
            <v-divider class="my-4" />

            <!-- Acciones -->
            <v-card-actions>
              <v-btn 
                block
                large
                color="black"
                class="white--text mt-2"
                style="border-radius: 10px; text-transform: none; font-weight: 600;" 
                @click="createInvoice()"
              >
                Guardar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDisposicion" v-if="dialogDisposicion" max-width="1000px">
        <v-card style="border-radius: 20px; padding: 24px;">
          <v-card-title style="font-family: 'montserrat-bold'; font-size: 22px;">
            Generar Disposición
            <v-spacer />
            <v-col cols="4">
              <v-text-field
                v-model="fechaDisposicion"
                label="Fecha de disposición"
                type="date"
                outlined
                style="border-radius: 10px;"
                hide-details
              />
            </v-col>
          </v-card-title>

          <v-divider class="my-4" />
          <v-row class="mb-6" style="font-family: 'montserrat-bold'; font-size: 16px;">
            <v-col cols="12">
            Cliente: {{ facturasSeleccionadas[0]?.enterprise_name }}
            </v-col>
            <v-col cols="6">
              <v-card
                flat
                class="d-flex align-center justify-center flex-column py-2"
                style="background-color: #f6f6f6; border-radius: 12px; height: 100%; "
                >
                <div class="mb-1" style="font-family: 'montserrat-bold'; font-size: 14px; color: #333;">
                  Monto total disponible en la línea de crédito
                </div>
                <div style="font-family: 'montserrat-bold'; font-size: 20px; color: #333;">
                  {{ "$ " + formatMoney(creditLine?.available_amount) + " " + creditLine?.currency }}
                </div>
              </v-card>
            </v-col>
            <v-col cols="6" class="text-right">
              <v-card
                flat
                class="d-flex align-center justify-center flex-column py-2"
                style="background-color: #f6f6f6; border-radius: 12px; height: 100%; "
                >
                <div class="mb-1" style="font-family: 'montserrat-bold'; font-size: 14px; color: #333;">
                  Monto total a utilizar de la línea de crédito
                </div>
                <div style="font-family: 'montserrat-bold'; font-size: 20px; color: #333;">
                  {{ "$ " + formatMoney(totalUsarLineaCredito()) + " " + creditLine?.currency }}
                </div>
              </v-card>
            </v-col>
          </v-row>
          <v-divider class="my-4" />
          <div v-for="(facturas, currency) in groupedByCurrency()" :key="currency">
            <div class="d-flex align-center mb-4">
              <div class="mb-2" style="font-family: 'montserrat-bold'; font-size: 22px;">
                Moneda: {{ currency }}
              </div>
              <v-spacer />
              <v-text-field
                v-if="currency != facturas[0].credit_line_currency"
                v-model="costosDisposicion[currency]"
                label="Costo de disposición"
                outlined
                style="border-radius: 10px;"
                hide-details
                required
              />
            </div>
            
            <v-data-table
              :headers="headersDisposicion"
              :items="facturas"
              disable-pagination
              hide-default-footer
              dense
              >
              <template v-slot:item.issue_date="{ item }">
                {{ formatDate(item.issue_date) }}
              </template>
              <template v-slot:item.due_date="{ item }">
                {{ formatDate(item.due_date) }}
              </template>
              <template v-slot:item.amount="{ item }">
                $ {{ formatMoney(item.amount) }} {{ item.currency }}
              </template>
            </v-data-table>

            <div class="mt-5 mb-6" style="text-align: right; font-size: 20px; font-family: 'montserrat-bold';">
              Total a recibir en {{ currency }}: $
              {{ formatMoney(facturas.reduce((sum, f) => sum + Number(f.amount), 0)) + " " + currency }}
            </div>
            <v-file-input
              v-model="comprobantesDisposicion[currency]"
              :label="'Comprobante de pago ' + currency + ' (PDF)'"
              accept=".pdf"
              outlined
              style="border-radius: 10px;"
              hide-details
              prepend-icon="mdi-paperclip"
              class="mb-4"
            />
          </div>

          <v-divider class="my-4" />

          <v-card-actions class="justify-end" style="font-family: 'montserrat-bold';">
            <v-btn rounded text @click="dialogDisposicion = false, facturasSeleccionadas = [], fetchFacturas()" class="px-4">Cancelar</v-btn>
            <v-btn :disabled="creditLine?.available_amount < totalUsarLineaCredito() || !fechaDisposicion" rounded color="black" class="white--text px-4" @click="confirmarDisposicion()">
              Confirmar disposición
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      search: '',
      dialogCreateInvoice: false,
      dialogDisposicion: false,
      enterprisesList: [],
      facturas: [],
      factura: {
        sEnterpriseId: '',
        invoice_id: '',
        reference: '',
        amount: '',
        currency: '',
        issue_date: '',
        due_date: '',
      },
      pdfFile: null,
      menuEmision: false,
      menuVencimiento: false,
      facturasSeleccionadas: [],
      rules: {
        required: (v) => !!v || "El campo es obligatorio",
      },
      headersDisposicion: [
        { text: 'Referencia', value: 'reference' },
        { text: 'Fecha de emisión', value: 'issue_date' },
        { text: 'Fecha de vencimiento', value: 'due_date' },
        { text: 'Monto', value: 'amount' },
      ],
      creditLine: null,
      fechaDisposicion: new Date().toISOString().substr(0, 10),
      costosDisposicion: {},
      comprobantesDisposicion: {},
    };
  },
  methods: {
    async getEnterprisesList() {
      this.enterprisesList = [];

      try {
        const res = await DB.get(`${URI}/api/v1/en/admin/credit/credit_lines/enterpriseList`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ''
          }
        });
        this.enterprisesList = res.data.enterprises || [];
      } catch (err) {
        this.$toast.error('Error al cargar empresas');
      }
    },
    async fetchFacturas() {
      this.facturas = [];

      try {
        const res = await DB.get(`${URI}/api/v1/en/admin/credit/creditInvoices`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ''
          }
        });
        this.facturas = res.data.invoices || [];
      } catch (err) {
        this.$toast.error('Error al cargar facturas');
      } finally {
        this.isLoading = false;
      }
    },
    async getEnterpriseCreditLine() {
      try {
        const response = await DB.post(`${URI}/api/v1/en/admin/credit/credit_lines`, this.factura, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : '',
          }
        });
        this.fetchFacturas();
        this.creditLine = response.data.creditLine;
      } catch (err) {
        this.$toast.error('Error al crear factura');
      }
    },
    async createInvoice() {
      const isValid = await this.$refs.formNew.validate();

      if (!isValid) {
        this.mixError('Revisa los campos obligatorios antes de continuar');
        return;
      }

      try {
        const formData = new FormData();
        formData.append('sEnterpriseId', this.factura.sEnterpriseId);
        formData.append('invoice_id', this.factura.invoice_id);
        formData.append('reference', this.factura.reference || '');
        formData.append('amount', this.factura.amount);
        formData.append('currency', this.factura.currency);
        formData.append('issue_date', this.factura.issue_date);
        formData.append('due_date', this.factura.due_date);
        if (this.pdfFile) {
          formData.append('pdf_file', this.pdfFile);
        }

        const response = await DB.post(`${URI}/api/v1/en/admin/credit/creditInvoices`, formData, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : '',
            'Content-Type': 'multipart/form-data',
          }
        });
        this.pdfFile = null;
        this.fetchFacturas();
        this.dialogCreateInvoice = false;
      } catch (err) {
        this.$toast.error('Error al crear factura');
      }
    },
    async viewDocument(item) {
      try {
        const res = await DB.get(`${URI}/api/v1/en/admin/credit/creditInvoices/${item.id}/document`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ''
          }
        });
        window.open(res.data.url, '_blank');
      } catch (err) {
        this.$toast.error('Error al obtener el documento');
      }
    },
    formatMoney(amount) {
      return new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    },
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    statusColor(status) {
      return {
        pending: 'grey',
        funded: 'blue',
        partially_paid: 'orange',
        paid: 'green'
      }[status] || 'grey';
    },
    groupedByCurrency() {
      const grouped = {};
      this.facturasSeleccionadas.forEach(factura => {
        const currency = factura.currency;
        if (!grouped[currency]) {
          grouped[currency] = [];
        }
        grouped[currency].push(factura);
      });

      return grouped;
    },
    async confirmarDisposicion() {
      const grouped = this.groupedByCurrency();
      const creditLineId = this.creditLine.id;
      const requests = [];

      for (const currency in grouped) {
        const facturas = grouped[currency];
        const invoice_ids = facturas.map(f => f.id);
        const creditLineCurrency = facturas[0].credit_line_currency;

        const payload = {
          credit_line_id: creditLineId,
          invoice_ids,
          disbursed_currency: currency,
          disbursed_at: this.fechaDisposicion,
        };

        // Si la moneda de las facturas NO coincide con la de la línea => se requiere total_cost
        if (currency !== creditLineCurrency) {
          const costo = this.costosDisposicion[currency];
          if (!costo) {
            this.$toast.error(`Debes ingresar el costo de disposición para la moneda ${currency}`);
            return;
          }

          payload.total_cost = costo;
        }

        const formData = new FormData();
        formData.append('credit_line_id', creditLineId);
        formData.append('invoice_ids', JSON.stringify(invoice_ids));
        formData.append('disbursed_currency', currency);
        formData.append('disbursed_at', this.fechaDisposicion);
        if (payload.total_cost) {
          formData.append('total_cost', payload.total_cost);
        }
        if (this.comprobantesDisposicion[currency]) {
          formData.append('payment_receipt', this.comprobantesDisposicion[currency]);
        }

        requests.push(
          DB.post(`${URI}/api/v1/en/admin/credit/credit_draws`, formData, {
            headers: {
              Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : '',
              'Content-Type': 'multipart/form-data',
            }
          })
        );
      }

      try {
        await Promise.all(requests);
        this.$toast.success('Disposición(es) generada(s) correctamente');
        this.dialogDisposicion = false;
        this.facturasSeleccionadas = [];
        this.costosDisposicion = {};
        this.comprobantesDisposicion = {};
        this.fetchFacturas(); // recarga
      } catch (err) {
        this.$toast.error('Hubo un error al generar las disposiciones');
        console.error(err);
      }
    },
    async getCreditLine(item) {
      this.payload = {
        sEnterpriseId: item.sEnterpriseId,
      };

      try {
        const response = await DB.post(`${URI}/api/v1/en/admin/credit/credit_lines/getCreditLine`, this.payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : '',
          }
        });
        this.creditLine = response.data.creditLine;
      } catch (err) {
        this.$toast.error('Error al crear línea de crédito.');
      }
    },
    totalUsarLineaCredito() {
      let total = 0;

      const grouped = this.groupedByCurrency();

      for (const currency in grouped) {
        const facturas = grouped[currency];
        const isMismaMoneda = facturas[0].credit_line_currency === currency;

        if (isMismaMoneda) {
          total += facturas.reduce((sum, f) => sum + Number(f.amount), 0);
        } else {
          const costo = Number(this.costosDisposicion[currency]) || 0;
          total += costo;
        }
      }

      return total;
    }
  },
  computed: {
    clienteSeleccionado() {
      return this.facturasSeleccionadas.length > 0
        ? this.facturasSeleccionadas[0].sEnterpriseId
        : null;
    },
    filteredFacturas() {
      if (!this.search) return this.facturas;
      const filtro = this.search.toLowerCase();
      return this.facturas.filter(item => {
        return (
          (item.enterprise_name || '').toLowerCase().includes(filtro) ||
          (item.invoice_id || '').toLowerCase().includes(filtro) ||
          (item.reference || '').toLowerCase().includes(filtro) ||
          (item.currency || '').toLowerCase().includes(filtro) ||
          (item.status || '').toLowerCase().includes(filtro) ||
          (item.provider || '').toLowerCase().includes(filtro) ||
          String(item.amount).includes(filtro)
        );
      });
    }
  },
  beforeMount() {
    this.fetchFacturas();
    this.getEnterprisesList();
  },
};
</script>

<style scoped>
.header__title {
  font-family: 'montserrat-semibold';
  font-size: 13px;
  padding: 12px;
}
.header__title.left {
  text-align: left;
}
.header__title.center {
  text-align: center;
}
</style>
